(function($, undefined) {
	
	// uses record-RTC.js plugin
	
	'use strict';
	const LIMIT_RECORDING_MINUTES = 30;
	var utils;
	var audioRecordOpenActionsBtn;
	var audioPreviewPopup;
	
	var audioRecordBtn;
	var stopRecordBtn;
	var pauseRecordBtn;
	var listenRecordBtn;
	var redoRecordBtn;
	
	var mediaRecorder;
	var timerId;
	var timer;
	var startedRecording = false;
	var isRecording = false;
	
	var recordedBlob = undefined;
	
	var mediaConstraints = {
		audio: {
			mandatory: {
				echoCancellation: false,
				googAutoGainControl: false,
				googNoiseSuppression: false,
				googHighpassFilter: false
			},
			optional: [{
			  googAudioMirroring: false
			}]
		},
	};
	
	var init = function () {
		utils = Fw.component.models().utils;
		audioRecordOpenActionsBtn = $('.record-open-actions-btn');
		audioPreviewPopup = $('#audio-record-preview-popup');
		audioRecordBtn = $('.record-btn');
		stopRecordBtn = $('.stop-recording-btn');
		pauseRecordBtn = $('.pause-btn');
		listenRecordBtn = $('.listen-recording-btn');
		redoRecordBtn = $('.redo-recording-btn');
		timer = $('.timer');
		
		if ($('.record-audio-ctn').length > 0) {
			if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
				console.log('Audio recording not supported in this browser');
				$('.record-open-actions-btn').attr('disabled', true);
			}
		}
		
		audioRecordOpenActionsBtn.on('click', openAudioRecordActions);
		audioRecordBtn.on('click', startAudioRecorder);	
		pauseRecordBtn.on('click', pauseRecording);
		stopRecordBtn.on('click', stopRecording); // will call mediaRecorder.ondataavailable	
		listenRecordBtn.on('click', openListenRecordingPopup);
		redoRecordBtn.on('click', restartRecording);
		
		$('.recording-toggle-floating-div-btn').on('click', toggleAudioFloatingDivPos);
		
		$(window).on('scroll', function() {
			if ($('.record-audio-ctn .step-1').hasClass('hide') && !utils.isElementInScrollView($('.record-audio-ctn .record-btn-wrapper'))) {
				$('.recording-floating-div').addClass('show');
			} else {
				$('.recording-floating-div').removeClass('show');
			}
		});
	};
	
	var openAudioRecordActions = function() {
		$('.record-audio-ctn .step-2').removeClass('hide');	
		$('.record-audio-ctn .step-1').addClass('hide');	
	};
	
	var updateDisabledButtons = function() {
		if (isRecording) {
			audioRecordBtn.attr('disabled', true);
			stopRecordBtn.removeAttr('disabled');
			pauseRecordBtn.removeAttr('disabled');
			$('.audio-record-content').addClass('recording');
			$('.recording-floating-div').addClass('recording');
		} 
		else {
			audioRecordBtn.removeAttr('disabled');
			pauseRecordBtn.attr('disabled', true);
			stopRecordBtn.attr('disabled', true);
			listenRecordBtn.attr('disabled', true);
			redoRecordBtn.attr('disabled', true);
			$('.audio-record-content').removeClass('recording');
			$('.recording-floating-div').removeClass('recording');
		}
	};
	
	var updateStopDisabledButtons = function() {
		audioRecordBtn.attr('disabled', true);
		pauseRecordBtn.attr('disabled', true);
		stopRecordBtn.attr('disabled', true);
		listenRecordBtn.removeAttr('disabled');
		redoRecordBtn.removeAttr('disabled');
		$('.audio-record-content').removeClass('recording');
		$('.recording-floating-div').removeClass('recording');
	};
	
	var onMediaSuccess = function(stream) {
		mediaRecorder = new RecordRTC(stream, {type: 'audio'});
		mediaRecorder.setRecordingDuration(60 * 1000 * 30).onRecordingStopped(function(audioUrl) { // auto stop recording after 30 minutes
			stopRecording();
		});
		mediaRecorder.startRecording();
		startedRecording = true;
		isRecording = true;
		startTimer();
		updateDisabledButtons();
	};
	
	var onMediaError = function(e) {
		console.error('media error', e);
		$('.record-open-actions-btn').attr('disabled', true);
		$('.record-audio-ctn .step-2').addClass('hide');	
		$('.record-audio-ctn .step-1').removeClass('hide');
	};
	
	var startAudioRecorder = function() {
		if (startedRecording) {
			resumeRecording();
		} else {
			navigator.mediaDevices.getUserMedia(mediaConstraints).then(onMediaSuccess).catch(onMediaError);
		}
	};
	
	var pauseRecording = function() {
		if (mediaRecorder) { mediaRecorder.pauseRecording(); }
		stopTimer();
		isRecording = false;
		updateDisabledButtons();
	};
	
	var stopRecording = function() {
		mediaRecorder.stopRecording(function(audioUrl) {
			fillAudioPreviewPopup(audioUrl);
			recordedBlob = mediaRecorder.getBlob();
			
			$('.exercise-detail-ctn').trigger('exercise-completion-change');
			startedRecording = false;
			isRecording = false;
			stopTimer();
			updateStopDisabledButtons();
		});
	};
	
	var resumeRecording = function() {
		if (mediaRecorder) { mediaRecorder.resumeRecording(); }
		startTimer();
		isRecording = true;
		updateDisabledButtons();
	};
	
	var restartRecording = function() {
		if (mediaRecorder) { mediaRecorder.clearRecordedData(); }
		recordedBlob = undefined;
		resetTimer();
		startedRecording = false;
		isRecording = false;
		updateDisabledButtons();	
		$('.exercise-detail-ctn').trigger('exercise-completion-change');
	};
	
	var startTimer = function() {
		timerId = setInterval(updateTimer, 1000);
	};
	var resetTimer = function() {
		stopTimer(timerId);
		timer.text('00:00');
	};
	
	var updateTimer = function() {
		var currentTimeArray = timer.first().text().split(':');
		var seconds = parseInt(currentTimeArray[1]);
		var minutes = parseInt(currentTimeArray[0]);
		if (minutes < LIMIT_RECORDING_MINUTES) {
			if (seconds + 1 >= 60) {
				minutes = minutes + 1;
				seconds = 0;
			}
			else {
				seconds = seconds + 1;
			}
			var newTimeString = formatNumberTwoDigits(minutes) + ':' + formatNumberTwoDigits(seconds);
			timer.text(newTimeString);
		} 
		else {
			stopRecording();
		}
	};

	var stopTimer = function() {
		clearInterval(timerId);
	};
	
	
	/**
	 * Have to save the file as a Blob because the File()
	 * constructor is not yet implemented in Edge (2018-06-15)
	 */
	var saveRecording = function(callback = () => {}) {
		if ($('.record-audio-ctn').length > 0) {
			var file = recordedBlob; //new File([recordedBlob], 'recording.mp3');
			if (file) {
				var formData = new FormData();
				formData.append('image', file, 'recording.mp3'); // filename is very important (for the extension)
				formData.append('directory', 'Recordings');
				formData.append('offsetX', '0');
				formData.append('offsetY', '0');
				formData.append('ajax', 'true');
				
				$.ajax({
					url: "/action/uploadCroppedImage",
					method: "post",
					data: formData,
					cache : false,
					processData: false,
					contentType: false,
					success: function(response) {
						console.log(response);
						if (response.indexOf('success') !== -1) {
							var mediaId = response.replace('success?mediaId=', '').trim();
							$('.record-audio-ctn').attr('data-media-id', mediaId); // to be used in exercises-save.js
							recordedBlob = undefined;
							callback();
						}
					},
					error: function(jqxhr, status, error) {
						console.log(status + ' ' + error);
					}
				});
			}
			else {
				callback();
			}
		} 
		else {
			callback();
		}
	};
	
	var openListenRecordingPopup = function() {
		audioPreviewPopup.addClass('visible');
	};
	
	var fillAudioPreviewPopup = function(audioUrl) {
		var audioElement = audioPreviewPopup.find('audio')[0];
		audioElement.addEventListener('loadedmetadata', function() {
			// handle chrome's bug
			if(audioElement.duration === Infinity) {
				// set it to bigger than the actual duration
				audioElement.currentTime = 1e101;
				$(audioElement).one('timeupdate', function(){
					audioElement.currentTime = 0;
				});
			}
		});
		$(audioElement).one('play', function() {
			audioElement.currentTime = 0;
		});
		audioElement.src = audioUrl;
		audioElement.load();
	};
	
	var createAudioUrl = function(blob) {
		return window.URL.createObjectURL(blob);
	};
	
	var formatNumberTwoDigits = function(num) {
		var prefix = num < 10 ? '0' : '';
		return prefix + num;
	};
	
	var hasRecording = function() {
		return recordedBlob !== undefined;
	};
	
	var toggleAudioFloatingDivPos = function() {
		var t = $(this);
		var div = t.closest('.recording-floating-div');
		div.toggleClass('low');
	};
	
	$(window).ready(function () {
		init();
	});
	
	var AudioRecorder = Fw.component.export('AudioRecorder', {
		saveRecording: saveRecording,
		hasRecording: hasRecording
	});
	
})(jQuery);



